

namespace cdh {
    var _ready = $.Deferred();
    var cultureCookieName = "cdh.culture";
    var locales: localization.languageDef[] = [
        { locale: "de", culture: "de-DE" },
        { locale: "en", culture: "en-US" },
        { locale: "fr", culture: "fr-FR" }];

    const prefix = "cdh.pmCloud.";
    var suffix: string = null;
    export var uid: number; // TODO getUserID/Name

    export const ready = _ready.promise();
    export const isBusy = utils.createBusyCounter();

    const actionRegex = /(?:^|&|#|\?)action=([a-zA-z-0-9]+)((?:,[a-zA-z-0-9]+)+)?(?=&|$)/i;// Q> add arguments

    export const actions: Dictionary<{ (args: string[]): Promise<void> }> = {};
    export const actionHandlers: { (name: string, args: string[]): [boolean, null | Promise<void>] }[] = []
    export function runAction(name: string, args: string[]): Promise<void> {
        var p: Promise<void> = null;

        if (actions[name])
            p = actions[name](args);
        else {
            for (var i = 0; i < actionHandlers.length; i++) {
                var res = actionHandlers[i](name, args);
                if (res[0]) {
                    p = res[1];
                    break;
                }
            }
        }

        if (p) {
            // Q> Add Errorhandling?
        }

        return p;
    }

    export function createActionWrapper(action: ObservableOrValueReadonly<(IActionDefinition | IActionGroupDefinition)[]>): { (name: string, args: string[]): [boolean, null | Promise<void>] } {

        if (!action) return null;

        return (name, args) => {
            // Q> Naming Conventions
            //    How should nested Actions be handled?
            var tmp = ko.unwrap(action);
            var q: (IActionDefinition | IActionGroupDefinition)[] = [];

            if (tmp)
                q.push(...tmp);

            while (q.length) {
                var a = q.shift();
                if (utils.equalsIgnoreCase(a.name, name)) {
                    if (a.click)
                        a.click(null);
                    return [true, null];
                }

                if ("items" in a) {
                    tmp = ko.unwrap(a.items);
                    if (tmp)
                        q.push(...tmp);
                }

            }

            return [false, null];
        }


    }

    function runHashAction(newHash: string): boolean {
        var mAction = actionRegex.exec(newHash);
        if (mAction) {
            var name = mAction[1];
            var args = mAction[2] ? mAction[2].split(",").slice(1) : [];

            runAction(name, args);
            var tmp = location.hash.replace(mAction[0], "");
            if (tmp == "#")
                tmp = null;
            location.hash = tmp;

            return true;
        }

        return false;
    }

    function parseHash(newHash: string, oldHash: string) {

        if (!runHashAction(newHash))
            crossroads.parse(newHash);
    }

    var lTitle = ko.observable("");
    var d = isBusy.beginUsing(lTitle)

    export const menu = new (class MenuContainer {
        readonly isCollapsed = ko.observable(false);
        readonly isHover = ko.observable(false);
        readonly isOpen = ko.observable(false);
        readonly widgets = ko.observableArray<IWidgetDefinition>();

        private readonly _closeDelay = 100;

        readonly userActions = ko.pureComputed(() => {
            var res: IActionGroupDefinition[] = [];

            //res.push({
            //    name: "userProperties",
            //    caption: t2("userProperties/title"),
            //    click: async () => {
            //        var vm = new data.UserPropertyEditorViewModel();

            //        await vm.showDialog();

            //        await userContext.reload();
            //    }

            //});

            if (cdh.notificationConfig.isEnabled()) {
                res.push({
                    name: "notifications",
                    caption: notification.NotificationRepository.editorDialogOptions.title,
                    click: async () => {
                        var rep = new notification.NotificationRepository();

                        var s = rep.createSearcher();
                        s.defaultCommand.redirectCommand = "edit";

                        await s.showDialog("none");
                    }

                });

            }



            return res;
        });

        close() {
            var self = this;
            setTimeout(() => self.isHover(false), self._closeDelay);
        }

    })();
    actionHandlers.push(createActionWrapper(menu.userActions));


    $(async function () {
        let b = document.body;
        let loadPanel = document.createElement("div");

        b.append(loadPanel);
        ko.applyBindingsToNode(loadPanel, { dxLoadPanel: ui.getLoadPanelOptions({ visible: isBusy as any }) });

        ui.DialogContainer.defaultBusyCounter = isBusy;
        ui.breakpoints["default"] = { classPrefix: 'bp', points: [{ name: 's' }, { name: 'l', min: 600 }] };

        notification.defaultRefType = "pmc";
        notification.defaultLink = ko.pureComputed(() => {
            //var cfg = config();
            var url: string;
            var desc: string;

            //if (cfg && cfg.website)
            //    url = cfg.website.baseUrl;

            if (!url) {
                url = location.origin + Router.baseUrl;
            }
            url = url + "#action=notifications";
            desc = t("view/notifications/linkText");

            return { url, desc };
        });

        utils.LocalOptionManager.prefix = prefix;

        try {
            utils.defaultTemplateGroup = g => Router.action("Home", "Templates", { groupName: g });

            hasher.initialized.add(parseHash); //parse initial hash
            hasher.changed.add(parseHash); //parse hash changes

            await cdh.localization.initGlobalize({
                cultureCookieName: cultureCookieName,
                locales: locales,
                cldrDataPath: "~/lib/cldr-data/"
            });

            lTitle(t("data/common/loading"));

            initResizing();


        if (cdh.uid) {
            suffix = utils.LocalOptionManager.suffix = "@" + cdh.uid;
            utils.terms.provider(new utils.StorageRecentTerms(prefix + "terms" + suffix, "local"));
        }

            await initConfig();
            if (cdh.uid) {
                initSidebar()
            }

            hasher.init();

            if (cdh.ui != null) {
                cdh.ui.bindLazyContentLoaders();
                cdh.ui.bindModel(".main-menu", menu);
            }
        }
        finally {
            d.dispose();
        }

        _ready.resolve();
    });

    export interface IUserContextExtensions {

        //getOptions(key: "general.userInfo"): Readonly<data.IUserInfo>;
        //getOptions(key: "general.notificationInfo"): Readonly<data.INotificationInfo>;

    }


    type MenuOptions = {
        collapsed: boolean
    };
    function initSidebar() {
        const key = prefix + "menu" + suffix;

        let isHover = menu.isHover, isNotPinned = menu.isCollapsed, isOpen = menu.isOpen;

        utils.addLocalOptionsListener(key, applyMenuOptions);
        applyMenuOptions();

        let moSaveAction = new utils.DelayedAction(saveMenuOptions, 500);
        let menuOptions = ko.computed(() => {
            var res: MenuOptions = {
                collapsed: isNotPinned()
            };

            return res;

        });
        menuOptions.subscribe(o => moSaveAction.schedule());

        let b = document.body;
        let $nav = $("#nav-main");

        $("#nav-main-toggle").on("click", e => {
            var _mo = !ko.unwrap(isHover);
            isHover(_mo);

            if (_mo) {
                $nav.find(".nav-toggable").focus();
            }
        }).on("focusout", e => {
            checkOnFocusOut(e.relatedTarget as Element);
        });
        $nav.on("mouseenter", e => {
            isHover(true);
        });
        $nav.on("mouseleave", e => {
            checkOnMouseLeave(e.relatedTarget as Element);
        }).on("focusout", e => {
            checkOnFocusOut(e.relatedTarget as Element);
        });
        $(b).on("click", ".nav-toggable", e => {
            if (ko.unwrap(isNotPinned)) {
                let _mo = isHover();
                isHover(!_mo);

                if (_mo) {
                    //e.preventDefault();
                    //e.stopPropagation();
                    //return false;
                }
                else if (e.currentTarget)
                    e.currentTarget.scrollIntoView();
            }
            else
                isHover(true);
        });
        $nav.on("click", ".nav-toggable-hide", e => {
            // Use Timeout to ensure all other hover/focus Events are finished before changing the observable
            setTimeout(() => isHover(false), 5);
        });

        $(b).on("mouseleave", ".dx-gesture-cover, .dx-overlay-content, .dx-overlay-wrapper", e => {
            checkOnMouseLeave(e.relatedTarget as Element);
        }).on("focusout", ".dx-overlay-wrapper", e => {
            checkOnFocusOut(e.relatedTarget as Element);
        });

        ko.computed(() => {

            let isP = !ko.unwrap(isNotPinned);
            let isO = isP || ko.unwrap(isHover);
            b.classList.toggle("nav-pinned", isP);
            b.classList.toggle("nav-open", isO);

            isOpen(isO);
            return isO;
        });

        function checkOnFocusOut(relTarget?: Element): boolean {
            if (!isHover.peek()) return;

            if (checkFocusInNav(relTarget, true)) {
                return;
            }

            isHover(false);
        }

        function checkOnMouseLeave(relTarget?: Element): boolean {
            if (relTarget) {
                var tar = $(relTarget);

                if (tar.hasClass("dx-gesture-cover")) {
                    return;
                }

                if (tar.closest(".dx-overlay-wrapper").length) {
                    return;
                }

                if (tar.closest("#nav-main").length) {
                    return;
                }
            }

            if (checkFocusInNav(document.activeElement, false)) {
                return;
            }


            isHover(false);
        }

        function checkFocusInNav(elm: Element, focusChange: boolean): boolean {
            if (elm) {
                var $elm = $(elm);
                // TODO Check whether the focused Element should keep the Menu open?

                if (/*focusChange &&*/ $elm.closest(".dx-overlay-wrapper").length) {
                    return true;
                }

                if ($elm.closest("#nav-main, .header-navbar").length) {
                    if (utils.equalsIgnoreCase(elm.tagName, "INPUT"))
                        return true;

                    if (focusChange && $elm.closest(".nav-widget, .nav-links")[0])
                        return true;
                }
            }

            return false;
        }

        function applyMenuOptions() {
            let mo = utils.getLocalOptions<MenuOptions>(key);
            if (!mo)
                mo = { collapsed: window.innerWidth <= 500 };



            isNotPinned(mo.collapsed !== false);
        }

        function saveMenuOptions() {
            let mo = ko.unwrap(menuOptions);

            utils.setLocalOptions(key, mo);
        }
    }

    function initResizing() {
        let header = document.getElementById("header");
        let footer = document.getElementById("footer");
        let contentWrapper = document.getElementById("content-wrapper");
        let contentBefore = document.getElementById("content-before");
        let contentAfter = document.getElementById("content-after");
        let contentSub = document.getElementById("content-sub");

        if (!contentWrapper && !contentSub)
            return;

        if (ResizeObserver && (header || footer)) {
            let ro = new ResizeObserver(applySize);

            if (header)
                ro.observe(header);
            if (footer)
                ro.observe(footer);
        }

        function applySize() {
            var hH = header ? header.clientHeight + "px" : "0";
            var fH = footer ? footer.clientHeight + "px" : "0";

            if (contentSub) {
                contentSub.style.top = hH;
                //contentSub.style.bottom = fH;
            }

            if (contentWrapper) {

                if (contentBefore) {
                    contentBefore.style.height = hH;
                }
                else {
                    let applyTop = false;
                    if (header) {
                        let cStyle = window.getComputedStyle(footer);
                        applyTop = cStyle.position == "fixed" || cStyle.position == "absolute";
                    }

                    if (applyTop)
                        contentWrapper.style.marginTop = hH;
                    else {
                        contentWrapper.style.marginTop = "0";
                    }
                }

                if (contentAfter) {

                    contentAfter.style.height = fH;
                }
                else {
                    let applyBottom = false;
                    if (footer) {
                        let cStyle = window.getComputedStyle(footer);
                        applyBottom = cStyle.position == "fixed" || cStyle.position == "absolute";
                    }

                    if (applyBottom)
                        contentWrapper.style.marginBottom = fH;
                    else {
                        contentWrapper.style.marginBottom = "0";
                    }
                }
            }
        }
    }

}

